// ✅ timing.js
// src/utils/timing.js

const START_TIME_KEY = 'startTime';
const TIME_TAKEN_KEY = 'timeTaken';

export function initStartTime() {
    const existing = localStorage.getItem(START_TIME_KEY);
  
    // 判斷不是 timestamp，就重新寫入
    if (!existing || isNaN(parseInt(existing, 10)) || existing.includes('GMT')) {
      const now = Date.now();
      localStorage.setItem(START_TIME_KEY, now);
      console.log('[timing] ✅ 設置正確 startTime:', now);
    } else {
      console.log('[timing] ✅ 已存在有效 startTime:', existing);
    }
  }
  
export function computeAndSaveTimeTaken() {
  const raw = localStorage.getItem(START_TIME_KEY);
  const start = parseInt(raw, 10);
  let taken = 300;
  if (!isNaN(start)) {
    taken = Math.floor((Date.now() - start) / 1000);
  }
  localStorage.setItem(TIME_TAKEN_KEY, taken);
  console.log('[timing] 🕒 儲存 timeTaken:', taken);
  return taken;
}

export function getTimeTakenSafe() {
  const rawTaken = parseInt(localStorage.getItem(TIME_TAKEN_KEY), 10);
  if (!isNaN(rawTaken) && rawTaken > 0) return rawTaken;

  const rawStart = parseInt(localStorage.getItem(START_TIME_KEY), 10);
  if (!isNaN(rawStart)) {
    const fallback = Math.floor((Date.now() - rawStart) / 1000);
    console.warn('[timing] ⏱ fallback 計算 timeTaken:', fallback);
    return fallback;
  }

  console.warn('[timing] ❌ fallback 到預設 300 秒');
  return 300;
}
